// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1pen9","productName":"Table_productName__mhbBY"};